import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    headList:'',
    // navIndex:0,
    // newsId:'',
  },
  mutations: {
	  getHeadList(state,e){
	  		 state.headList=e 
    },
    // changeNewsIndex(state,e){
    //   state.navIndex=e 
    // },
    // getNewsId(state,e){
    //   state.newsId=e.newsId
    // },
  },
  actions: {
  },
  modules: {
  }
})
